<template>
  <div class="checkbox" :class="inlineClass">
    <input :id="cbId"
           type="checkbox"
           :disabled="disabled"
           v-validate="isRequired"
           v-model="model"
           :name="name" />
    <label :for="cbId">
      <slot></slot>
    </label>
  </div>
</template>
<script>
  export default{
    name: 'p-checkbox',
    model: {
      prop: 'checked'
    },
    props: {
      checked: [Array, Boolean, Number],
      disabled: [Boolean, String],
      inline: Boolean,
      required: Boolean,
      name: String
    },
    data () {
      return {
        cbId: ''
      }
    },
    computed: {
      model: {
        get () {
          return this.checked === 1 || this.checked === true
        },
        set (check) {
          this.$emit('input', check ? 1 : 0)
        }
      },
      inlineClass () {
        if (this.inline) {
          return `checkbox-inline`
        }
      },
      isRequired () {
        if (this.required) {
          return 'required'
        } else {
          return ''
        }
      }
    },
    created () {
      this.cbId = Math.random().toString(16).slice(2)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/Checkbox.vue